var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleArrowUp = function SvgCircleArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#DAFDD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle_arrow_up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.18 22.427a.558.558 0 0 1 .067.591.558.558 0 0 1-.504.317h-5.53V36.782a1.17 1.17 0 0 1-1.168 1.168h-6.09a1.17 1.17 0 0 1-1.167-1.168V23.335h-5.53a.56.56 0 0 1-.438-.908l9.743-12.179A.554.554 0 0 1 24 10.05c.167 0 .332.067.436.198l9.743 12.179Zm-7.135 14.405h.05V22.776a.56.56 0 0 1 .559-.558h4.926l-.065-.082-8.476-10.595-.039-.049-.039.05-8.476 10.594-.065.082H20.347a.56.56 0 0 1 .559.558V36.832h6.139Z",
    fill: "#233E20",
    stroke: "#DAFDD7",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_arrow_up_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgCircleArrowUp;